import { Dayjs } from "dayjs";
import { useMemo } from "react";
import { DayIndicator } from "components/DateStepper";
import { useGetReviewMonthSummaryQuery } from "src/store/api/generatedApi";
import { useTenant } from "hooks/settings";

export const useTargetedReviewMonthIndicators = ({
  location,
  month,
  enabled,
}: {
  location: string | undefined;
  month: Dayjs;
  enabled: boolean;
}): {
  indicators: Map<string, DayIndicator> | undefined;
  isFetching: boolean;
  isError: boolean;
} => {
  const tenantName = useTenant();
  const monthStart = month.startOf("month").format("YYYY-MM-DD");
  const monthEnd = month.endOf("month").format("YYYY-MM-DD");

  const { currentData, isFetching, isError } = useGetReviewMonthSummaryQuery(
    {
      tenantName,
      location: location ?? "",
      monthStart,
      monthEnd,
      reviewReasons: ["likely_error", "confusable_material", "duplicate_mass"],
      projection: "targeted_summary",
      materialAreaFilterList: { items: [] },
    },
    { skip: !enabled || !location }
  );

  const indicators = useMemo(() => {
    if (!currentData) return undefined;
    return new Map<string, DayIndicator>(
      currentData.days.map((day) => {
        const count =
          (day.likely_error_count ?? 0) + (day.random_check_count ?? 0);
        return [
          day.date,
          {
            eventCount: count > 0 ? count : undefined,
            statusColour: count > 0 ? "error.main" : undefined,
          },
        ];
      })
    );
  }, [currentData]);

  return {
    indicators,
    isFetching: enabled && isFetching,
    isError: enabled && isError,
  };
};
